// Who gets offered the guided demo. A pure function so the rule is testable
// without a DOM.
//
// The status lives in user_profiles.onboarding_status:
//   NULL        — never offered; eligible for the auto-offer
//   'declined'  — skipped the offer, or left the demo early
//   'completed' — watched it through
//
// The column's CHECK constraint also permits 'paused_awaiting_ami', left over
// from the tour this demo replaced. Nothing writes it any more; it stays
// allowed so the constraint needs no migration, and rows still holding it were
// reset to NULL so those accounts get offered the demo instead.

import type { OnboardingStatus } from '../types/auth';

/**
 * Auto-offer the demo only to accounts that have never been offered it AND own
 * no projects. A null count means the ownership check failed — treat as
 * ineligible, so a transient error can never nag an established user.
 */
export function isTourAutoOfferEligible(
  status: OnboardingStatus | null | undefined,
  ownProjectCount: number | null,
): boolean {
  return status == null && ownProjectCount === 0;
}
